// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__4jJ2e","checkboxCol":"Table_checkboxCol__3543a","emailCol":"Table_emailCol__1ImZI","actionCol":"Table_actionCol__1hTvi"};